// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3hVBt","requiredAsterisk":"Info_requiredAsterisk__3Gdp_"};